export const UNDERSTANDING_SECTION = "UNDERSTANDING_SECTION";
export const UNDERSTANDING_ERROR = "UNDERSTANDING_ERROR";
export const UNDERSTANDING_HIDE_ERROR = "UNDERSTANDING_HIDE_ERROR";
